export const AppName = "Compras";
export const AppTestEnv = "staging";

export const AllowedLanguages = ["pt", "en", "es"] as const;
export type AllowedLanguagesCode = (typeof AllowedLanguages)[number];
export const FallbackLng: AllowedLanguagesCode = "pt";
export const localStorageLanguageKey = "language";
export interface LanguageInfo {
  code: string;
  name: string;
}

export const LanguagesInfo: Record<AllowedLanguagesCode, LanguageInfo> = {
  pt: { code: "pt", name: "Português" },
  en: { code: "en", name: "English" },
  es: { code: "es", name: "Español" },
};

export type Lang = "pt" | "en" | "es";

export const defaultPageSize = 15;
export const defaultCPVPageSize = 15;

export const dateHoursFormat = "yyyy-MM-dd HH:mm:ss";

export const presentationDateFormat = "dd/MM/yyyy";

export const presentationDateTimeFormat = "yyyy-MM-dd HH:mm";

export const internalDateFormat = "yyyy-MM-dd";

export const roleIdAdmin = 2;
export const roleIdUser = 3;

export const allPublicContractId = 1;
export const adsPublicContractId = 2;
export const joraaPublicContractId = 3;

export const countryIdPortugal = 1;

export const acinPhone = "707 451 451";
export const acinEmailSupport = "apoio@comprasdoestado.com";
export const acinAddress =
  "Estrada Regional 104 N.42-A 9350-203 Ribeira Brava - Madeira";
export const acinPrivacyPolityUrl = "https://acin.pt/politica-privacidade";
export const acinUrl = "https://acin.pt";
export const acinFax = "+351 291 957 171";

export const serviceIds = {
  base: 1,
  plus: 2,
  premium: 3,
  free: 4,
};

export const paymentExpiredThresholdDays = 0;

export const privacyIds = {
  sourceUser: 1,
  sourceEntity: 2,
  actionDelete: 2,
  statusPending: 4,
};

export const servicesUrl = "https://acin.pt/#services";

export const certifiedClientDirectoryUrl =
  "https://www.sgsgroup.cz/en/vr/certified-client-directory";

export const servicePricingPeriodIdFreeService = 4;

export const applicationAlertTypesIds = {
  warning: 2,
};

export const limitDaysRemainingOnSubscription = 10;

export const linkConditionsPT = "assets/documents/conditions_pt.pdf";
export const linkConditionsEN = "assets/documents/conditions_en.pdf";
export const linkConditionsES = "assets/documents/conditions_es.pdf";

export const linkConditions = {
  pt: linkConditionsPT,
  en: linkConditionsEN,
  es: linkConditionsES,
};

export const sgsUrl =
  "https://sgs.com/en/certified-clients-and-products/certified-client-directory";

export const urgentPublicContractAnnouncementModel =
  "urgent-public-contract-announcement-model";

export const clarificationRequestDeadlineModel =
  "clarification_request_deadline";

export const errorsAndOmissionsDeadlineModel = "errors_omissions_deadline";

export const facebookLink =
  "https://www.facebook.com/profile.php?id=100080613547772";

export const instagramLink =
  "https://www.instagram.com/comprasdoestado.portugal";

export const COOKIE_KEY = "@acin-ui:cookiesAccepted";

export const GREYS_400 = "#AAAAAA";
